export default __webpack_public_path__ + "static/media/how-to-use-rig-01.abc480ef.jpg";